module.exports = __webpack_public_path__ + "img/icon-mh-sj.37aac082.png";